import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";
import {
  ITradeQueryRequestService,
  CHANNEL_TRADE_QUERY_REQUEST,
} from "../ITradeQueryRequestService";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { TraderGroupLookupService } from "../../lookup/model/impl/TraderGroupLookupService";

import { Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

export abstract class TradeQueryRequestPromiseService implements ITradeQueryRequestService {
  abstract request(tradeQuery: CubiqTS.TradeQueryRequest): Promise<CubiqTS.StandardReport>;

  abstract requestAdaptedTradeData(tradeQuery: CubiqTS.TradeQueryRequest): Promise<Array<any>>;
}
